import { BACKEND_URI } from '@/config/env'
import axios, { Axios } from 'axios'
import { redirectToLogin } from '../utils/authRedirect'
import { useAuthStore } from '../store/auth/useAuthStore'
import useChartStore from '../store/chart/useChartStore'
import useCustomizeLiveStore from '../store/live/useCustomizeLiveStore'
import { PostLoginRequestType } from '../types/apiResponse/authorizationTypes'
import { authDebug } from '../utils/authDebug'

const authClient: Axios = axios.create({
  baseURL: BACKEND_URI,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

export const login = async (data: PostLoginRequestType) => {
  authDebug.loginRequest(data.email)
  const res = await authClient.post('auth/login', data)
  authDebug.loginResponse(res.status, res.headers as unknown as Record<string, string>)
  authDebug.cookieState('after login response')
  return res
}

let isLoggingOut = false

export const logout = () => {
  if (isLoggingOut) return
  isLoggingOut = true

  // 즉시 store 정리 및 리다이렉트 (API 응답 기다리지 않음)
  useChartStore.getState().reset()
  useCustomizeLiveStore.getState().reset()
  useAuthStore.getState().logout()
  useChartStore.persist.clearStorage()
  useCustomizeLiveStore.persist.clearStorage()

  // 백그라운드로 logout API 호출 (실패해도 무관)
  authClient.post('auth/logout').catch(() => {})

  redirectToLogin()
  isLoggingOut = false
}
